<template>
  <div class="audclbanner">
    <div class="top between">
      <div class="audcl_left">
        <el-carousel
          height="340px"
          indicator-position="none"
          :interval="5000"
          ref="audclbanner"
          @change="swichan"
          arrow="never"
          @mouseenter.native="autoplayHandler"
        >
          <el-carousel-item
            v-for="(item,index) in baulist1"
            :key="index"
            @click.native="tojump(item)"
          >
            <img :src="item.preview_pic" class="swimg" />
          </el-carousel-item>
        </el-carousel>
        <div class="audcl_lebottom between">
          <div class="des" v-if="baulist1[swiactiv] && baulist1[swiactiv].title">
            <svg-icon icon-class="linear-play" class="svgplay" />

            {{baulist1[swiactiv].title}}
          </div>
          <div class="flex_end">
            <div
              class="switm_yd"
              v-for="(item, index) in baulist1"
              :key="index"
              :class="{ activ: swiactiv == index }"
              @click="setswi(index)"
            ></div>
          </div>
        </div>
      </div>
      <div class="audcl_right">
        <sub-title text="精选语音推荐" style="font-size: 20px" />
        <div class="list">
          <div
            class="item"
            v-for="(item, index) in baulist2"
            :key="index"
            @click="tojump(item)"
          >
            <div class="title ellipsis">{{ item.title }}</div>
            <div class="itb between">
              <div class="time center">
                <img src="../../../assets/claim/yuyin_c.png" alt="" />
                {{ item.duration }}
              </div>
              <div class="stnum">
                <span>{{ item.view_num }}</span
                >次收听
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "../../home/components/subTitle";
export default {
  components: {
    subTitle,
  },
  data: () => ({
    swiactiv: 0,
    baulist1: [],
    baulist2: [],
  }),
  beforeMount() {
    this.getao1list();
    this.getao2list()
  },
  methods: {
    autoplayHandler() {
      this.$refs.audclbanner.handleMouseEnter = () => {};
    },
    swichan(index) {
      this.swiactiv = index;
    },
    setswi(index) {
      this.$refs.audclbanner.setActiveItem(index);
    },
    tojump(item) {
      this.$router.push({
        path: "/laws/audioimdet",
        query: {
          audioinId: item.id,
        },
      });
    },
    getao1list() {
      let data = {
        limit: 4,
        page: 1,
        order: "hot",
      };
      this.$http.laws.getaudiolist(data).then((res) => {
        this.baulist1 = res.data.data;
      });
    },
    getao2list() {
      let data = {
        limit: 4,
        page: 1,
        order: "hot",
      };
      this.$http.laws.getaudiolist(data).then((res) => {
        this.baulist2 = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scope>
.audclbanner {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .top {
    align-items: flex-start;
    .audcl_left {
      width: 856px;
      height: 340px;
      position: relative;
      .swimg {
        width: 100%;
        height: 100%;
      }
      .audcl_lebottom {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 44px;
        line-height: 44px;
        color: #fff;
        background-color: rgba($color: #000000, $alpha: 0.4);
        padding: 0 40px 0 27px;
        .des {
          font-size: 16px;
          color: #ffffff;
          cursor: pointer;
          .svgplay {
            vertical-align: -0.2em;
            color: #ffffff;
            font-size: 22px;
            border-radius: 50%;
            margin-right: 12px;
          }
        }
        .switm_yd {
          cursor: pointer;
          width: 10px;
          height: 10px;
          background: #ffffff;
          border-radius: 50%;
          margin-right: 14px;
          &.activ {
            background: #0465ea;
          }
        }
      }
    }
    .audcl_right {
      width: 314px;
      padding: 24px 20px 22px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      .list {
        .item {
          cursor: pointer;
          width: 100%;
          margin-top: 24px;
          .title {
            font-size: 16px;
            line-height: 16px;
            color: #333333;
          }
          .itb {
            margin-top: 14px;
            font-size: 14px;
            line-height: 14px;
            .time {
              color: #999999;
              img {
                margin-right: 8px;
              }
            }
            .stnum {
              color: #666666;
              span {
                color: #da0b0b;
              }
            }
          }
        }
      }
    }
  }
}
</style>